import { render, staticRenderFns } from "./OrderStepTransportAndPaymentItem.vue?vue&type=template&id=047d65bd&"
import script from "./OrderStepTransportAndPaymentItem.vue?vue&type=script&lang=js&"
export * from "./OrderStepTransportAndPaymentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports